import * as types from './actionTypes'

const initialState = {
    isAuthorized: false,
    list: [],
    autologinFailed: false,
    isLoading: false,
    permissions: {},
    username: '',
    logo: {},
    url: null,
	instance: ''
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.LOGIN_FETCH:
            return {
                ...state,
                isAuthorized: false,
                isLoading: true
            }

        case types.LOGIN_FETCH_SUCCESS:
            return {
                ...state,
                isAuthorized: true,
                isLoading: false,
                autologinFailed: false,
                permissions: action.data.Permissions,
                username: action.data.UserName,
                logo: action.data.UserImage
            }

        case types.LOGIN_FETCH_FAILED:
            return {
                ...state,
                isAuthorized: false,
                isLoading: false
            }

        case types.REGISTRATION_FETCH:
            return {
                ...state,
                isAuthorized: false,
                isLoading: true
            }

        case types.REGISTRATION_FETCH_SUCCESS:
            return {
                ...state,
                isAuthorized: true,
                isLoading: false,
                permissions: action.data.Permissions,
                username: action.data.UserName,
                logo: action.data.UserImage
            }

        case types.REGISTRATION_FETCH_FAILED:
            return {
                ...state,
                isAuthorized: false,
                isLoading: false
            }

        case types.AUTOLOGIN_FETCH:
            return {
                ...state,
                isAuthorized: false,
                autologinFailed: false,
                isLoading: true
            }

        case types.AUTOLOGIN_FETCH_SUCCESS:
            return {
                ...state,
                isAuthorized: true,
                autologinFailed: false,
                isLoading: false,
                permissions: action.data.Permissions,
                username: action.data.UserName,
                logo: action.data.UserImage
            }

        case types.AUTOLOGIN_FETCH_FAILED:
            return {
                ...state,
                isAuthorized: false,
                autologinFailed: true,
                isLoading: false
            }

        case types.LOGOUT_FETCH_SUCCESS:
            return {
                ...initialState
            }

        case types.LOGOUT_FETCH_FAILED:
            return {
                ...state,
                isAuthorized: true
            }

        case types.INSTANCES_FETCH_SUCCESS:
            return {
                ...state,
				instance: action.instance ? action.instance : action.list[0],
                list: [...action.list]
            }

        case types.INSTANCES_FETCH_FAILED:
            return {
                ...state
            }

        case types.SET_USER_DATA:
            return {
                ...state,
                isLoading: true
            }

        case types.SET_USER_DATA_SUCCESS:
            return {
                ...state,
                isLoading: false,
                permissions: action.data.Permissions,
                username: action.data.UserName,
                logo: action.data.UserImage
            }

        case types.SET_USER_DATA_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.CHANGE_PASSWORD:
            return {
                ...state,
                isLoading: true
            }

        case types.CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                isLoading: false
            }

        case types.CHANGE_PASSWORD_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.GET_CALL_URL:
            return {
                ...state,
                isLoading: true
            }

        case types.GET_CALL_URL_SUCCESS:
            return {
                ...state,
                isLoading: false,
                url: action.url
            }

        case types.GET_CALL_URL_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.SET_CALL_URL:
            return {
                ...state,
                isLoading: true
            }

        case types.SET_CALL_URL_SUCCESS:
            return {
                ...state,
                isLoading: false,
                url: action.url
            }

        case types.SET_CALL_URL_FAILED:
            return {
                ...state,
                isLoading: false
            }

        default:
            return state
    }
}
